export default __webpack_public_path__ + "static/media/8-thumbs-up_1f44d.bcaa027b.png";